var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "float-label",
    {
      attrs: {
        large: _vm.large,
        "large-on-desktop": _vm.largeOnDesktop,
        "full-width": _vm.fullWidth,
        placeholder: _vm.placeholder,
        value: _vm.value,
        "hide-label": _vm.hideLabel,
        type: _vm.type
      }
    },
    [
      _c("input", {
        staticClass: "vs-input",
        class: _vm.classes,
        style: _vm.style,
        attrs: {
          type: _vm.type || "text",
          name: _vm.name,
          "aria-label": _vm.placeholder,
          "aria-describedby": _vm.describedById,
          "aria-invalid": _vm.error ? "true" : "false",
          "aria-disabled": _vm.disabled ? "true" : "false",
          "aria-required": !!_vm.errorId,
          autocomplete: _vm.autocomplete,
          readonly: _vm.readonly,
          placeholder: _vm.hideLabel ? _vm.placeholder : null
        },
        domProps: { value: _vm.value },
        on: {
          input: function($event) {
            return _vm.$emit("input", $event)
          },
          keyup: function($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            ) {
              return null
            }
            return _vm.$emit("search", { target: { value: _vm.value } })
          },
          focus: _vm.focusIn,
          blur: _vm.focusOut
        }
      }),
      _vm.type === "search"
        ? _c("div", {
            staticClass: "vs-input__search mdi mdi-magnify",
            on: {
              click: function($event) {
                return _vm.$emit("search", { target: { value: _vm.value } })
              }
            }
          })
        : _vm._e(),
      _vm.clearable && _vm.value
        ? _c("div", {
            staticClass: "vs-input__clear mdi mdi-close",
            on: { click: _vm.handleClear }
          })
        : _vm._e(),
      _vm.showToolTip
        ? _c(
            "div",
            { staticClass: "vs-input__help" },
            [
              _c("vs-help", {
                attrs: {
                  message: _vm.helpHtml,
                  "tooltip-inner-id": _vm.tooltipInnerId
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm.hexColor
        ? _c(
            "swatches",
            {
              attrs: {
                "popover-to": "right",
                colors: _vm.hexColorIsText ? "text-basic" : "basic"
              },
              model: {
                value: _vm.vuexHexColor,
                callback: function($$v) {
                  _vm.vuexHexColor = $$v
                },
                expression: "vuexHexColor"
              }
            },
            [
              _c("div", {
                staticClass: "vs-input__hex",
                style: { backgroundColor: _vm.hexColor },
                attrs: { slot: "trigger" },
                slot: "trigger"
              })
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }